import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrawer4"><Path d="M2.5 4.5H21.5V16.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 4.75V16.25" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 8.5L14.5 11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 16.75L19.5 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 8.5L9.5 11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 16.75L4.5 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrawer4;
